export const IMAGE_ATTRIBUTE = "attachment_image";

export const FILE_ATTRIBUTES = [
  "attachment_file",
  "attachment_pdf",
  "attachment_audio",
  "attachment_video",
];

export const EMBED_ATTRIBUTE = "embed";

export const ACCEPT_BY_ATTRIBUTE: Record<string, string[]> = {
  attachment_image: ["image/*"],
  attachment_video: ["video/*"],
  attachment_audio: ["audio/*"],
  attachment_pdf: ["application/pdf"],
  attachment_file: [
    "image/*",
    "video/*",
    "audio/*",
    "application/*",
    "text/*",
    "font/*",
  ],
};

export const TAB_VALUES = {
  upload: "upload",
  embed: "embed",
  findOnline: "find-online",
} as const;

export type TabValue = (typeof TAB_VALUES)[keyof typeof TAB_VALUES];

export const EMBED_FORM_ID = "editor-attachment-embed-form";

export const FIND_ONLINE_FORM_ID = "editor-attachment-find-online-form";
